import { defaultFeatureFlagsKey, makeDefaultLoadableContent } from '../store.utils';
import { userSelectors } from './userSelectors';
/**
 * Returns the businessId to be used as the key to get the feature-flags.
 * Will be the vendor businessId if user is a client and we're in a relationship context.
 */ function ffBusinessId(s) {
    const { relationshipVendorId } = s.ff;
    return userSelectors.isClient(s) && relationshipVendorId || userSelectors.businessId(s);
}
/** Returns the LoadableContent of the feature-flags for the relevant businessId. */ function featureFlags(s) {
    return s.ff.featureFlags[ffBusinessId(s) || defaultFeatureFlagsKey] || makeDefaultLoadableContent();
}
function featureFlagsByBusinessId(s, businessId) {
    const key = businessId || defaultFeatureFlagsKey;
    return s.ff.featureFlags[key] || makeDefaultLoadableContent();
}
function featureFlagsDataByBusinessId(s, businessId) {
    return featureFlagsByBusinessId(s, businessId).data || {};
}
function defaultFeatureFlags(s) {
    return s.ff.featureFlags[defaultFeatureFlagsKey] || makeDefaultLoadableContent();
}
/** Returns the actual feature-flags data for the relevant businessId. */ const featureFlagsData = (s)=>{
    const targetBusinessId = ffBusinessId(s) || defaultFeatureFlagsKey;
    const targetFF = s.ff.featureFlags[targetBusinessId];
    // If target feature flags exist and have data, return them
    if (targetFF && targetFF.data) {
        return targetFF.data;
    }
    // If target feature flags don't exist or are loading but don't have data yet, fall back to previous valid feature flags
    if (!targetFF || targetFF.loading && !targetFF.data) {
        // Fall back to user's business feature flags if available
        const userBusinessId = userSelectors.businessId(s);
        if (userBusinessId && userBusinessId !== targetBusinessId) {
            const userBusinessFF = s.ff.featureFlags[userBusinessId];
            if (userBusinessFF && userBusinessFF.data) {
                return userBusinessFF.data;
            }
        }
        // Fall back to default feature flags if available
        const defaultFF = s.ff.featureFlags[defaultFeatureFlagsKey];
        if (defaultFF && defaultFF.data) {
            return defaultFF.data;
        }
    }
    // Return target feature flags (even if loading/empty) or default empty
    return (targetFF === null || targetFF === void 0 ? void 0 : targetFF.data) || {};
};
export const ff = {
    ffBusinessId,
    featureFlags,
    featureFlagsData,
    defaultFeatureFlags,
    featureFlagsByBusinessId,
    featureFlagsDataByBusinessId
};
